<template>
  <div>
    <b-card
    >
      <b-dropdown
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          text="عملیات "
          variant="outline-primary"
          style="width:  300px"
      >
        <b-dropdown-item>
          <b-button style="width:  250px" class="  d-inline-block" variant="outline-primary"   @click="showSetByAdmin=true">فعال سازی رایگان توسط ادمین</b-button>
        </b-dropdown-item>
        <b-dropdown-item>
          <b-button style="width: 250px" class=" d-inline-block" variant="outline-primary"   @click="showTransferOrder=true">انتقال صورت حساب به کاربری دیگر</b-button>

        </b-dropdown-item>
        <b-dropdown-item>
          <b-button style="width: 250px" class=" d-inline-block" variant="outline-primary"  @click="showSettleCash=true">فعال سازی رژیم جدید با دریافت وجه</b-button>
        </b-dropdown-item>

      </b-dropdown>
      <b-table
          bordered
          hover
          striped
          responsive
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          :busy="loading"
          :no-local-sorting="true"
          @sort-changed="sortChange"
      >
        <template #cell(Id)="row">
          <b-link
              :to="{ }"
              class="font-weight-bold"
          >
            #{{ row.value }}
          </b-link>
        </template>
        <template #cell(Order.CreatedAt)="row">
          {{ row.value | date }}
          {{new Date(row.value).toLocaleTimeString('en-GB') | time}}
        </template>
         <template #cell(Order.DietTypeText)="row">
           <div style="width:150px">
             <p>
               سفارش:
               {{ row.value }}
             </p>
             <p v-if="row.item.Term">
               ترم:
               {{ row.item.Term.DietTypeText }}
             </p>
           </div>
        </template>

        <template #cell(DietDurationName)="data">
          {{ data.item.DietDurationPrice.Diet.Title }}
        </template>
        <template #cell(DietDurationPeriod)="data">
          {{ data.item.DietDurationPrice.DietDuration.Title }}
        </template>
        <template #cell(Order.Price)="data">
          <div v-if="data.item.Price.ActivityPrice>0">
            <p> رژیم:
              {{data.item.Price.DietPrice | price }}
            </p>
            <p> ورزش:
            {{data.item.Price.ActivityPrice | price}}
            </p>
              <p> مجموع:
            {{data.item.Price.Total | price }}
            </p>

          </div>
          <div v-else>
            {{ data.value | price }}
          </div>
        </template>
        <template #cell(Order.PaymentType)="data">
          <div style="width:130px">
            <p>{{data.value}}</p>
            <p>
              کد:
              {{data.item.Order.TransactionId}}</p>
          </div>

        </template>
        <template #cell(Order.IsPaid)="data">
          <b-badge
              v-if="data.value"
              variant="success"
          >
            پرداخت شده
          </b-badge>
          <b-badge
              v-else
              variant="warning"
              @click="showModal(data.item)"
          >
            پرداخت نشده
          </b-badge>
        </template>
        <template #cell(InCallQueue)="data">
          <feather-icon v-if="data.item.Order.InCallQueue" class="mr-1" icon="CheckSquareIcon" size="20" />
          <feather-icon v-else  class="mr-1" icon="SquareIcon" size="20" />
        </template>
        <template #cell(Term.IsDeactive)="data">
          <b-badge
              v-if="!data.value && data.item.Term !== null"
              variant="success"
          >
            فعال
          </b-badge>
          <b-badge
              v-else
              variant="warning"
              @click="showModal(data.item)"
          >
            غیر فعال
          </b-badge>
        </template>
        <template #cell(ActivityDietOrder)="data">
          <b-badge
              v-if="data.value"
              variant="success"
          >
            بله
          </b-badge>
          <b-badge
              v-else
              variant="warning"
              @click="showModal(data.item)"
          >
            خیر
          </b-badge>
        </template>
        <template #cell(Term.StartDate)="row">
          <p v-if="row.item.Term">
            شروع:
            {{ row.value | date }}
          </p>
          <p v-if="row.item.Term">
            پایان:
            {{ row.item.Term.EndDate | date }}
          </p>

        </template>

        <template #cell(show_details)="row">
          <feather-icon
              :icon="row.detailsShowing? 'EyeOffIcon':'EyeIcon'"
              size="16"
              @click="row.toggleDetails"
          />
        </template>

        <template #row-details="row">
          <b-card>
            <template v-for="order in row.item.OrderDetails">
              <b-row class="mb-2">
                <b-col
                    md="2"
                    class="mb-1"
                >
                  <strong>تاریخ: </strong>{{ order.CreatedAt | date }}
                  <strong> - </strong>{{new Date(order.CreatedAt).toLocaleTimeString('en-GB') | time}}
                </b-col>
                <b-col
                    md="2"
                    class="mb-1"
                >
                  <strong> وضعیت پرداخت: </strong>{{ order.StatusText }}
                </b-col>
                <b-col
                    class="mb-1"
                >
                  <strong> توضیحات: </strong>{{ order.Description }}
                </b-col>
                 <b-col
                    class="mb-1"
                    v-if="order.AttacheFile"
                >
                   <a
                       :href='order.AttacheFile'
                       target="_blank"
                   > فایل </a>
                 </b-col>

              </b-row>
            </template>
            <b-button
                size="sm"
                variant="outline-secondary"
                @click="row.toggleDetails"
            >
              بستن
            </b-button>
          </b-card>
        </template>
        <template #table-busy>
          <div
              class="text-center my-2"
          >
            <b-spinner
                variant="primary"
                class="align-middle"
            />
            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
          </div>
        </template>
        <template #cell(actions)="data">
          <feather-icon icon="SettingsIcon" @click="showSettingModal=true;modalInfo=data" />
        </template>
      </b-table>
      <z-pagination
          :per-page="5"
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="dietOrders"
      />
      <b-modal
          v-model="isShow"
          v-if="isShow"
          ok-title="ذخیره"
          cancel-title="انصراف"
          cancel-variant="outline-secondary"
          centered
          modal-class="confirm-pay-modal"
          title="تایید پرداخت"
          :no-close-on-backdrop="true"
          size="sm"
          @ok="confirmPay"
      >
        <div>
          پرداخت مورد نظر تایید شود؟
        </div>
      </b-modal>
       <b-modal
          v-model="showActiveCanDiet"
          ok-title="تایید"
          cancel-title="انصراف"
          cancel-variant="outline-secondary"
          centered
          modal-class="confirm-pay-modal"
          title="فعال سازی رژیم بدون نیاز به تماس"
          :no-close-on-backdrop="true"
          size="sm"
          @ok="saveActiveCanDiet"
      >
        <div>
          آیا از انجام این کار مطمئن هستید؟
        </div>
      </b-modal>

    </b-card>
    <b-modal
        v-model="showSetByAdmin"
        ok-title="تاید"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="فعال سازی رایگان توسط ادمین"
        :no-close-on-backdrop="true"
        size="md"
          @ok="saveSetByAdmin"
          @cancel="showSetByAdmin=false;form={}"
    >
      <div>
        <b-form-group
            label="انتخاب رژیم"
        >
          <diet-duration-price-select
              v-model="form.DietDurationPriceId"
              autocomplete="off"
              :multiple="false" />
        </b-form-group>
      </div>
    </b-modal>
    <b-modal
        v-model="showSettleCash"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="فعال سازی رژیم جدید با دریافت وجه"
        :no-close-on-backdrop="true"
        size="md"
          @ok="saveSettleCash"
          @cancel="showSettleCash=false;form={}"
    >
      <div>
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="مبلغ"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  تومان
                </b-input-group-prepend>
                <cleave
                    v-model="form.Price"
                    class="form-control"
                    :raw="false"
                    :options="{
                  numeral: true,
               }"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
              class="image"
              cols="12"
          >
            <fm-file-select v-model="form.AttacheFile" label="عکس فیش" :entity="18" />
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="انتخاب رژیم"
            >
            <diet-duration-price-select v-model="form.DietDurationPriceId" autocomplete="off" :multiple="false" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
<b-modal
        v-model="showVerifyOrder"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="فعال سازی تراکنش بانکی"
        :no-close-on-backdrop="true"
        size="md"
          @ok="saveVerifyOrder"
          @cancel="showVerifyOrder=false;form={}"
    >
      <div>
        <b-row>
          <b-col
              class="image"
              cols="12"
          >
            <fm-file-select v-model="form.AttacheFile" label="عکس فیش" :entity="18" />
          </b-col>
          <b-col>
            <b-form-textarea
                id="Description"
                v-model="form.Description"
                name="Description"
                autocomplete="off"
            />
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
        v-model="showChangeDietTypeByCash"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تغییر رژیم با دریافت مابه التفاوت"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveChangeDietTypeByCash"
        @cancel="showChangeDietTypeByCash=false;form={}"
    >
      <div>
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="مبلغ"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  تومان
                </b-input-group-prepend>
                <cleave
                    v-model="form.Price"
                    class="form-control"
                    :raw="false"
                    :options="{
                  numeral: true,
               }"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <diet-duration-price-select v-model="form.DietDurationPriceId" autocomplete="off" :multiple="false" />
          </b-col>
          <b-col
              class="image mt-2"
              cols="12"
          >
            <fm-file-select v-model="form.AttacheFile" label="عکس فیش" :entity="18" />
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
        v-model="showChangeDietType"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تغییر رژیم بدون دریافت وجه"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveChangeDietType"
        @cancel="showChangeDietType=false;form={}"
    >
      <div>
        <diet-duration-price-select v-model="form.DietDurationPriceId" autocomplete="off" :multiple="false" />
      </div>
    </b-modal>
     <b-modal
        v-model="showSetActivation"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تغییر وضعیت دوره"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveSetActivation"
        @cancel="showSetActivation=false;form={}"
    >
      <div>
        <b-row>
          <b-col cols="12">
            <b-form-textarea
                id="Description"
                v-model="form.Description"
                name="Description"
                autocomplete="off"
            />
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="وضعیت"
            >
              <v-select
                  v-model="form.IsDeactive"
                  :options="enums('IsDeactive')"
                  dir="rtl"
                  label="text"
                  :reduce="x => x.value"
                  :clearable="false"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  <b-modal
        v-model="showChangeExpierTime"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تغییر تاریخ انقضای دوره"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveChangeExpierTime"
        @cancel="showChangeExpierTime=false;form={}"
    >
      <div>
        <b-row>
          <b-col cols="12">
            <b-form-textarea
                id="Description"
                v-model="form.Description"
                name="Description"
                autocomplete="off"
            />
          </b-col>
          <b-col cols="12">
            <b-form-group
                label=" تاریخ"
                label-for="StartDate"
            >
              <date-picker
                  v-model="form.Date"
                  placeholder=""
                  type="date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jD"
              />
            </b-form-group>
          </b-col>

        </b-row>

      </div>
    </b-modal>
    <b-modal
        v-model="showReturnMoney"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="بازگشت وجه"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveReturnMoney"
        @cancel="showReturnMoney=false;form={}"
    >
      <div>
        <b-row>
          <b-col cols="12">
            <b-form-textarea
                id="Description"
                v-model="form.Description"
                name="Description"
                autocomplete="off"
            />
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
        v-model="showTransferOrder"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="انتقال صورت حساب به کاربری دیگر"
        :no-close-on-backdrop="true"
        size="md"
        @ok="saveTransferOrder"
        @cancel="showTransferOrder=false;form={}"
    >
      <div>
        <div>
          <b-row>
            <b-col>
              <p>
                نام :
                {{userData.Name || 'ندارد'}}
              </p>
            </b-col>
            <b-col>
              <p>
                فامیلی:
                {{userData.Family || 'ندارد'}}
              </p>
            </b-col>
            <b-col>
              <p>
                موبایل:
                {{userData.Mobile || 'ندارد'}}
              </p>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <b-form-group label="کاربر جایگزین">
              <b-form-input v-model="form.NewUserId" >
              </b-form-input>
            </b-form-group>
            <b-button @click="getNewUserInfo" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary">دریافت اطلاعات کاربر جایگزین <b-spinner
                v-show="newUserLoading"
                small
                class="btn-loading"
            /></b-button>
            <div class="mt-5">
              <p>اطلاعات کاربر جایگزین</p>
              <p>
                نام:
                {{newUser.name}}
              </p>
              <p>
                فامیلی:
                {{newUser.family}}
              </p>
              <p>
                موبایل:
                {{newUser.mobile}}
              </p>
               <p>
                ایمیل:
                {{newUser.Email}}
              </p>

            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

   <b-modal
       v-model="showSettingModal"
       ok-only
       ok-title="بستن"
       @close="showSettingModal=false;form={}"
   >
      <div>
        <b-row>
          <b-col>
            <p>
              نام :
              {{userData.Name || 'ندارد'}}
            </p>
          </b-col>
          <b-col>
            <p>
              فامیلی:
              {{userData.Family || 'ندارد'}}
            </p>
          </b-col>
          <b-col>
            <p>
              موبایل:
              {{userData.Mobile || 'ندارد'}}
            </p>
          </b-col>
        </b-row>
        <div class="text-center w-100">
<!--            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showVerifyOrder=true;form.OrderId=modalInfo.item.Id" >فعال سازی تراکنش بانکی</b-button>-->
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showChangeDietTypeByCash=true;form.OrderId=modalInfo.item.Id">تغییر رژیم با دریافت مابه التفاوت</b-button>
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showChangeDietType=true;form.OrderId=modalInfo.item.Id">تغییر رژیم بدون دریافت وجه</b-button>
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showChangeExpierTime=true;form.OrderId=modalInfo.item.Id" >تغییر تاریخ انقضای دوره</b-button>
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showSetActivation=true;form.OrderId=modalInfo.item.Id">تغییر وضعیت دوره </b-button>
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showReturnMoney=true;form.OrderId=modalInfo.item.Id">بازگشت وجه </b-button>
            <b-button style="width: 400px" class="d-block my-1 mx-auto" variant="outline-primary"  @click="showActiveCanDiet=true;form.OrderId=modalInfo.item.Id">فعال سازی رژیم بدون نیاز به تماس</b-button>
        </div>
      </div>
   </b-modal>

  </div>
</template>
<script>
import UploadFile from "@/tools/uploadFile.vue";
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
import DietDurationPriceSelect from '@/tools/dietDurationPrice.vue'

export default {
  name: 'UserDietTerms',
  components: {FmFileSelect, UploadFile,DietDurationPriceSelect},
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
    userData: {
      type: [Object],
      default: ()=>({}),
    },

  },
  data() {
    return {
      loading: false,
      totalRows: null,
      isShow: false,
      row: null,
      showSettingModal:false,
      modalInfo:{},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Order.CreatedAt',
          label: 'تاریخ و ساعت',
          sortable: true,
        },
         {
             key: 'Order.DietTypeText',
             label: 'رژیم',
        },
        {
          key: 'Order.DietDuration',
          label: 'مدت',
        },
           {
          key: 'Order.Price',
          label: 'قیمت',
        },
        {
          key: 'Order.PaymentType',
          label: 'نحوه پرداخت',
        },
        {
          key: 'Order.IsPaid',
          label: 'وضعیت پرداخت',
        },
        {
          key: 'InCallQueue',
          label: 'انتظار تماس',
        },

        {
          key: 'ActivityDietOrder',
          label: 'سفارش همزمان ورزش',
        },
 {
          key: 'Coupon.Title',
          label: 'کپن تخفیف',
        },
        {
          key: 'Term.IsDeactive',
          label: 'وضعیت دوره',
        },
 {
          key: 'Term.StartDate',
          label: 'شروع دوره',
        },
        {
          key: 'show_details',
          label: '',
          thClass: 'col-width-50',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      items: [],
      filterOptions: {
        userId: this.userId,
        Page: 1,
        PerPage: 5,
        SortBy: null,
        IsDesc: true,
        Bank: [],
        DietDurationId: [],
        DietType: [],
        CouponId: [],
      },
      showSetByAdmin: false,
      showSettleCash:false,
      showVerifyOrder: false,
      showChangeDietTypeByCash: false,
      showChangeDietType:false,
      showSetActivation:false,
      showChangeExpierTime:false,
      showReturnMoney:false,
      showActiveCanDiet:false,
      showTransferOrder:false,
      form: {},
      newUser:{name:null,family:null,mobile:null},
      newUserLoading:false
    }
  },
  created() {
    this.dietOrders()
  },
  methods: {
    getNewUserInfo(){
      this.newUserLoading = true
      this.$http.post(
          this.$api.user.get, {
            'Id': this.form.NewUserId
      }).then(res=>{
        this.newUser.name = res.data.Name
        this.newUser.family=res.data.Family
        this.newUser.mobile=res.data.Mobile
        this.newUser.Email=res.data.Email
      }).finally(()=>{
        this.newUserLoading = false
      })
    },
    saveActiveCanDiet(){
      this.$http.post(
          this.$api.userdietorder.ActiveCanDiet, {
            "OrderId": this.form.OrderId,
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}
      })
    },
    saveTransferOrder(){
      this.$http.post(
          this.$api.userdietorder.transferOrder, {
            "UserId": this.userId,
            'NewUserId': this.form.NewUserId
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}
      })
    },
    saveReturnMoney(){
      this.$http.post(
          this.$api.userdietorder.returnMoney, {
            "UserId": this.userId,
            "OrderId": this.form.OrderId,
            "Description" : this.form.Description
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveChangeExpierTime(){
      this.$http.post(
          this.$api.userdietorder.changeExpierTime, {
            "UserId": this.userId,
            "EndDate": this.form.Date,
            "Description": this.form.Description,
            "OrderId" : this.form.OrderId
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveSetActivation(){
      this.$http.post(
          this.$api.userdietorder.setActivation, {
            "UserId": this.userId,
            "IsDeactive": this.form.IsDeactive,
            "Description": this.form.Description,
            "OrderId" : this.form.OrderId
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveChangeDietType(){
      this.$http.post(
          this.$api.userdietorder.changeDietType, {
            "UserId": this.userId,
            "DietDurationPriceId": this.form.DietDurationPriceId, //تغییر به رژیم
            "OrderId" : this.form.OrderId,
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveChangeDietTypeByCash(){
      this.$http.post(
          this.$api.userdietorder.changeDietTypeByCash, {
            "UserId": this.userId,
            "DietDurationPriceId": this.form.DietDurationPriceId, //تغییر به رژیم
            "OrderId" : this.form.OrderId,
            "Price" : this.form.Price.replaceAll(',',''),
            'AttacheFile':this.form.AttacheFile
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveVerifyOrder(){
      this.$http.post(
          this.$api.userdietorder.verifyOrder, {
            "AttacheFile": this.form.AttacheFile,
            "OrderId": this.form.OrderId,
            "Description" :  this.form.AttacheFile.Description
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveSettleCash(){
      this.$http.post(
          this.$api.userdietorder.settleCash, {
            "UserId": this.userId,
            "DietDurationPriceId": this.form.DietDurationPriceId, //رژیم خریداری شده
            "Price" : this.form.Price.replaceAll(',',''), //مبلغ پرداخت شده
            "AttacheFile" : this.form.AttacheFile //رسید پرداخت
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    saveSetByAdmin(){
      this.$http.post(
          this.$api.userdietorder.setByAdmin, {
            "UserId": this.userId,
            "DietDurationPriceId": this.form.DietDurationPriceId
          },
      ).then(()=>{
        this.dietOrders()
        this.form={}

      })
    },
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.dietOrders(1)
      }
    },
    dietOrders(pageNumber) {
      if (!this.$can('show', 'OrderView')) return
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$http.post(this.$api.userdietorder.getlist, this.filterOptions).then(res => {
        this.totalRows = res.totalRow
        this.items = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    editExpireDate(row) {
      this.showEditExpireDateModal = true
      this.ExpireDate = row.item.expireData
    },
    showModal(row){
      this.row = row
      this.isShow = true
    },
    confirmPay(){
      this.isShow = false
      this.$http.post(
          this.$api.userdietorder.confirmpay, {
            Id: this.row.Id,
          },
      )
          .then(res => {
            this.dietOrders()
            this.$emit('UserDietTerms')
            this.$emit('ActivityPackageOrder')
          })
    },
  },
}
</script>

<style>
  .tableActionCellWidth{
    width:500px;
  }
</style>
